import { useEffect, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import { IActionButton, ILink } from "./type";
import { useContext } from "preact/hooks";
import { NavbarContext } from "./context";
import toast from "react-hot-toast";
import { Fragment } from "preact/jsx-runtime";
import api from "./api";
import Swal from "sweetalert2";

export default function LinksSection() {
  const { links, buttons, save } = useContext(NavbarContext);

  const updateLinks = (links: ILink[]) => {
    const nLinks = links.map((link, index) => ({
      ...link,
      sort_num: index + 1,
    }));

    save({ links: nLinks });
  };

  const updateButtons = (buttons: IActionButton[]) => {
    const nButtons = buttons.map((button, index) => ({
      ...button,
      sort_num: index + 1,
    }));
    save({ buttons: nButtons });
  };

  useEffect(() => {
    document.addEventListener("click", () => {
      setShowNew(false);
      setShowNewActionButton(false);
    });
  }, []);

  const [showNew, setShowNew] = useState(false);
  const [showNewActionButton, setShowNewActionButton] = useState(false);
  return (
    <div class="navbarfooter-half-wrapper">
      <h4>Links</h4>

      <ReactSortable
        list={links.sort((a, b) => {
          return a.sort_num - b.sort_num;
        })}
        setList={(data, fresh, { dragging }) => {
          if (dragging) updateLinks(data);
        }}
      >
        <Fragment>
          {links.map((link, index) => {
            return (
              <Link
                key={index}
                link={link}
                onEdit={(link) => {
                  updateLinks(
                    links.map((l, i) => {
                      if (i === index) {
                        return link;
                      }
                      return l;
                    })
                  );
                }}
                onDelete={() => {
                  updateLinks(
                    links.filter((_, i) => {
                      return i !== index;
                    })
                  );
                }}
              />
            );
          })}
        </Fragment>
      </ReactSortable>
      <div
        class="dropdown-3 w-dropdown"
        data-delay="0"
        data-hover="false"
        style={{
          width: "100%",
        }}
      >
        <div
          class="button-white-with-shadow how-to-add-more-form-fields form-entry-select-dropdown for-dropdown w-dropdown-toggle"
          id="w-dropdown-toggle-3"
          aria-controls="w-dropdown-list-3"
          aria-haspopup="menu"
          aria-expanded="false"
          role="button"
          tabindex={0}
          onClick={(e) => {
            e.stopPropagation();
            setShowNew((v) => !v);
          }}
        >
          <div class="html-embed-icon mr-8 w-embed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-plus"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="CurrentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </div>
          <div>Add new link</div>
        </div>
        {showNew && (
          <LinksDropdown
            onDone={(link) => {
              setShowNew(false);
            }}
          />
        )}
      </div>
      <h4 class="mt-60">Action button</h4>

      {/* @ts-ignore */}
      <ReactSortable
        list={buttons}
        setList={(current, fresh, { dragging }) => {
          if (dragging) updateButtons(current);
        }}
      >
        {buttons
          .sort((a, b) => a.sort_num - b.sort_num)
          .map((actionButton, index) => {
            return (
              <ActionButton
                key={index}
                actionButton={actionButton}
                onEdit={(data) => {
                  updateButtons(
                    buttons.map((actionButton, i) => {
                      if (i === index) return data;
                      return actionButton;
                    })
                  );
                }}
              />
            );
          })}
      </ReactSortable>
      <div
        class="button-white-with-shadow how-to-add-more-form-fields"
        onClick={(e) => {
          e.stopPropagation();
          setShowNewActionButton(true);
        }}
      >
        <div class="html-embed-icon mr-8 w-embed">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon icon-tabler icon-tabler-plus"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="CurrentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </div>
        <div>Add new button</div>

        {showNewActionButton && (
          <ActionButtonDropdown
            onDone={(e) => {
              setShowNewActionButton(false);
              // updateButtons([...buttons, e]);
            }}
          />
        )}
      </div>
    </div>
  );
}

function SettingsIcon() {
  return (
    <div class="html-embed-icon w-embed">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon icon-tabler icon-tabler-settings"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="CurrentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
    </div>
  );
}

function DeleteIcon() {
  return (
    <div class="html-embed-icon w-embed">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon icon-tabler icon-tabler-trash"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="CurrentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <line x1="4" y1="7" x2="20" y2="7"></line>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
      </svg>
    </div>
  );
}

function MoveIcon({ onClick }: { onClick: () => void }) {
  return (
    <div class="html-embed-icon w-embed" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon icon-tabler icon-tabler-grip-vertical"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="CurrentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <circle cx="9" cy="5" r="1"></circle>
        <circle cx="9" cy="12" r="1"></circle>
        <circle cx="9" cy="19" r="1"></circle>
        <circle cx="15" cy="5" r="1"></circle>
        <circle cx="15" cy="12" r="1"></circle>
        <circle cx="15" cy="19" r="1"></circle>
      </svg>
    </div>
  );
}

function LinksDropdown({
  link = {
    id: 0,
    title: "",
    url: "",
    sort_num: 0,
    open_in_new_tab: false,
  },
  onDone,
}: {
  link?: ILink;
  onDone: (link: ILink) => void;
}) {
  const [linkState, setLinkState] = useState(link);
  const { saveLink } = useContext(NavbarContext);
  const [loading, setLoading] = useState(false);

  const save = async () => {
    try {
      setLoading(true);
      await saveLink(linkState);
      onDone(linkState);
      toast.success("Link saved");
    } catch (err) {
      console.log(err);
      toast.error("Error saving link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <nav
      style={{ zIndex: 16, position: "relative" }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        class="dropdown-list-proper"
        style={{ position: "absolute", right: "0px" }}
      >
        <div class="form-block-100">
          <form name="email-form" data-name="Email Form" method="get">
            <div class="dropdown-entry pb-0">
              <input
                type="text"
                class="form-entry-w-o-size-constraints w-input"
                defaultValue={linkState.title}
                onChange={(e: any) => {
                  setLinkState({
                    ...linkState,
                    title: e.target.value,
                  });
                }}
                placeholder="Button's title"
              />
            </div>
            <div class="dropdown-entry">
              <input
                type="text"
                class="form-entry-w-o-size-constraints w-input"
                placeholder="Send to this link: example.com/..."
                defaultValue={linkState.url}
                onChange={(e: any) => {
                  setLinkState({
                    ...linkState,
                    url: e.target.value,
                  });
                }}
              />
            </div>
            <div class="horizontal-divider mt-mb-5"></div>
            <div class="dropdown-entry">
              <div class="flex-horizontal-center-extremes-100 _100-width">
                <label class="w-checkbox dropdown-entry aligned-horizontally-relative">
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      setLinkState({
                        ...linkState,
                        open_in_new_tab: !linkState.open_in_new_tab,
                      });
                    }}
                    defaultChecked={linkState.open_in_new_tab}
                    class="w-checkbox-input checkbox-2"
                  />
                  <span
                    class="form-entry-w-o-size-constraints-copy w-form-label"
                    for="hide_branding-2"
                  ></span>
                  <div class="text-block-12">Open link in new tab</div>
                </label>
              </div>
            </div>
            <div class="horizontal-divider mt-mb-5"></div>
            <div class="dropdown-entry">
              {!loading ? (
                <input
                  type="submit"
                  value="Save changes"
                  class="button button-blue-primary button-block-centered-text mt-0 w-button"
                  onClick={(e) => {
                    e.preventDefault();
                    save();
                  }}
                />
              ) : (
                <div class="button button-blue-primary button-block-centered-text mt-0 w-button">
                  Saving...
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </nav>
  );
}

function Link({
  link,
  onEdit,
}: {
  link: ILink;
  onEdit: (link: ILink) => void;
  onDelete: () => void;
}) {
  const [showedit, setShowEdit] = useState(false);

  const { siteId, refetch } = useContext(NavbarContext);

  const remove = async () => {
    await api.deleteLink(siteId, link.id);
    refetch();
    return;
  };

  const deleteLink = async () => {
    Swal.fire({
      title: "Remove link",
      text: "Are you sure you want to remove this link?",
      showDenyButton: true,
      confirmButtonText: "Continue",
      denyButtonText: "Cancel",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        toast.promise(remove(), {
          loading: "Deleting link...",
          success: "Link deleted",
          error: "Error deleting link",
        });
      }
    });
  };

  useEffect(() => {
    document.addEventListener("click", () => {
      setShowEdit(false);
    });
  }, []);

  return (
    <div class="form-field-entry">
      <div class="flex-horizontal-center-left">
        <div class="button-in-form-field-entry mr-14 move-icon">
          <MoveIcon onClick={() => {}} />
        </div>
        <div class="navbarfooter-entry-title">{link.title}</div>
      </div>
      <div class="flex-horizontal-center-right">
        <div data-delay="0">
          <div
            class="button-in-form-field-entry for-dropdown w-dropdown-toggle"
            id="w-dropdown-toggle-3"
            aria-controls="w-dropdown-list-3"
            aria-haspopup="menu"
            aria-expanded="false"
            role="button"
            tabindex={0}
            onClick={(e: any) => {
              e.stopPropagation();
              setShowEdit(!showedit);
            }}
          >
            <SettingsIcon />
          </div>

          {showedit && <LinksDropdown link={link} onDone={onEdit} />}

          {/* navbar sections */}
        </div>
        <span
          class="button-in-form-field-entry w-inline-block"
          onClick={() => {
            deleteLink();
          }}
        >
          <DeleteIcon />
        </span>
      </div>
    </div>
  );
}

function ActionButton({
  onEdit,
  actionButton,
}: {
  actionButton: IActionButton;
  onEdit: (actionButton: IActionButton) => void;
}) {
  const [showedit, setShowEdit] = useState(false);

  useEffect(() => {
    document.addEventListener("click", () => {
      setShowEdit(false);
    });
  }, []);

  const { siteId, refetch } = useContext(NavbarContext);

  const remove = async () => {
    await api.deleteButton(siteId, actionButton.id);
    refetch();
    return;
  };

  const onDelete = async () => {
    Swal.fire({
      title: "Remove button",
      text: "Are you sure you want to remove this button?",
      showDenyButton: true,
      confirmButtonText: "Continue",
      denyButtonText: "Cancel",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        toast.promise(remove(), {
          loading: "Deleting button...",
          success: "Button deleted",
          error: "Error deleting button",
        });
      }
    });
  };

  return (
    <div id="add-new-website-button" class="form-field-entry">
      <div class="flex-horizontal-center-left">
        <div class="button-in-form-field-entry mr-14">
          <MoveIcon onClick={() => {}} />
        </div>
        <div class="navbarfooter-entry-title">{actionButton.title}</div>
      </div>
      <div class="flex-horizontal-center-right">
        <div data-delay="0" data-hover="false" class="dropdown-3 w-dropdown">
          <div
            class="button-in-form-field-entry for-dropdown w-dropdown-toggle"
            id="w-dropdown-toggle-4"
            aria-controls="w-dropdown-list-4"
            aria-haspopup="menu"
            aria-expanded="false"
            role="button"
            tabindex={0}
            onClick={(e: any) => {
              e.stopPropagation();
              setShowEdit(!showedit);
            }}
          >
            <SettingsIcon />
          </div>
          {showedit && (
            <ActionButtonDropdown
              actionButton={actionButton}
              onDone={(value) => {
                setShowEdit(false);
                onEdit(value);
              }}
            />
          )}
        </div>
        <a class="button-in-form-field-entry w-inline-block" onClick={onDelete}>
          <DeleteIcon />
        </a>
      </div>
    </div>
  );
}

function ActionButtonDropdown({
  actionButton = {
    id: 0,
    title: "",
    link: "",
    open_in_new_tab: false,
    sort_num: 0,
    style: "filled",
    shape: "rounded-rectangle",
    background_color: "",
    text_color: "",
  },
  onDone,
}: {
  actionButton?: IActionButton;
  onDone: (actionButton: IActionButton) => void;
}) {
  const [buttonState, setButtonState] = useState(actionButton);
  const [loading, setLoading] = useState(false);
  const { saveButton } = useContext(NavbarContext);

  const save = async () => {
    try {
      setLoading(true);
      await saveButton(buttonState);
      console.log("done saving");
      onDone(buttonState);
      toast.success("Button saved");
    } catch (err) {
      console.log(err);
      toast.error("Error saving button");
    } finally {
      setLoading(false);
    }
  };

  return (
    <nav style={{ zIndex: 12, position: "relative" }}>
      <div
        class="dropdown-list-proper"
        style={{ position: "absolute", right: "0px" }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div class="form-block-100">
          <form
            id="action-buttons"
            name="action-buttons"
            data-name="Email Form"
          >
            <div class="dropdown-entry pb-0">
              <input
                type="text"
                class="form-entry-w-o-size-constraints w-input"
                defaultValue={buttonState.title}
                onChange={(e: any) => {
                  setButtonState({
                    ...buttonState,
                    title: e.target.value,
                  });
                }}
                data-name="Title 3"
                placeholder="Button's title"
                id="Title-3"
              />
            </div>
            <div class="dropdown-entry">
              <input
                type="text"
                defaultValue={buttonState.link}
                onChange={(e: any) => {
                  setButtonState({
                    ...buttonState,
                    link: e.target.value,
                  });
                }}
                class="form-entry-w-o-size-constraints w-input"
                data-name="Help Text 3"
                placeholder="Send to this link: example.com/..."
              />
            </div>
            <div class="horizontal-divider mt-mb-5"></div>
            <div class="dropdown-entry">
              <select
                class="form-entry-select-dropdown _100-width w-select"
                name="fill"
                defaultValue={buttonState.style}
                onChange={(e: any) => {
                  setButtonState({
                    ...buttonState,
                    style: e.target.value,
                  });
                }}
              >
                <option value="filled">Main button (filled in)</option>
                <option value="outlined">Secondary button (outlined)</option>
              </select>

              <select
                class="form-entry-select-dropdown _100-width mt-10 w-select"
                defaultValue={buttonState.shape}
                name="shape"
                onChange={(e: any) => {
                  setButtonState({
                    ...buttonState,
                    shape: e.target.value,
                  });
                }}
              >
                <option value="rounded-rectangle">
                  Rounded Rectangle Button
                </option>
                <option value="rectangle">Rectangle Button</option>
                <option value="rounded">Rounded Button</option>
              </select>
              <div class="flex-horizontal-center-extremes-100 _100-width">
                <label class="w-checkbox dropdown-entry aligned-horizontally-relative mt-10">
                  <input
                    type="checkbox"
                    class="w-checkbox-input checkbox-2"
                    defaultChecked={buttonState.open_in_new_tab}
                    onChange={(e: any) => {
                      setButtonState({
                        ...buttonState,
                        open_in_new_tab: e.target.checked,
                      });
                    }}
                  />
                  <span
                    class="form-entry-w-o-size-constraints-copy w-form-label"
                    for="hide_branding-2"
                  ></span>
                  <div class="text-block-12">Open link in new tab</div>
                </label>
              </div>
            </div>

            <div class="horizontal-divider mt-mb-5"></div>

            <div class="dropdown-entry">
              <div class="flex-horizontal-center-extremes-100 _100-width">
                <label class="w-checkbox dropdown-entry aligned-horizontally-relative">
                  <input
                    type="checkbox"
                    id="has_background_color"
                    class="w-checkbox-input checkbox-2"
                    defaultChecked={!!buttonState.background_color}
                    onChange={(e: any) => {
                      setButtonState({
                        ...buttonState,
                        background_color: e.target.checked ? "black" : "",
                      });
                    }}
                  />
                  <span
                    class="form-entry-w-o-size-constraints-copy w-form-label"
                    for="has_background_color"
                  ></span>
                  <div class="text-block-12">Background colour</div>
                </label>
              </div>

              {buttonState.background_color && (
                <div class="dropdown-entry">
                  <div class="flex-horizontal-center-extremes-100 _100-width">
                    <input
                      type="color"
                      style="padding: 0px !important; width: 100% !important;"
                      class="form-entry-w-o-size-constraints w-input"
                      placeholder="#ffffff"
                      defaultValue={buttonState.background_color}
                      onChange={(e: any) => {
                        setButtonState({
                          ...buttonState,
                          background_color: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              <div class="flex-horizontal-center-extremes-100 _100-width">
                <label class="w-checkbox dropdown-entry aligned-horizontally-relative mt-10">
                  <input
                    type="checkbox"
                    class="w-checkbox-input checkbox-2"
                    defaultChecked={!!buttonState.text_color}
                    id="has_text_color"
                    onChange={(e: any) => {
                      setButtonState({
                        ...buttonState,
                        text_color: e.target.checked ? "black" : "",
                      });
                    }}
                  />
                  <span
                    class="form-entry-w-o-size-constraints-copy w-form-label"
                    for="has_text_color"
                  ></span>
                  <div class="text-block-12">Text colour</div>
                </label>
              </div>
            </div>

            {buttonState.text_color && (
              <div class="dropdown-entry">
                <div class="flex-horizontal-center-extremes-100 _100-width">
                  <input
                    type="color"
                    class="form-entry-w-o-size-constraints w-input"
                    placeholder="#ffffff"
                    style="padding: 0px !important; width: 100% !important;"
                    defaultValue={buttonState.text_color}
                    onChange={(e: any) => {
                      setButtonState({
                        ...buttonState,
                        text_color: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            )}

            <div class="horizontal-divider mt-mb-5"></div>
            <div class="dropdown-entry">
              {!loading ? (
                <input
                  onClick={(e) => {
                    e.preventDefault();

                    save();
                  }}
                  type="submit"
                  value="Save changes"
                  data-wait="Please wait..."
                  class="button button-blue-primary button-block-centered-text mt-0 w-button"
                />
              ) : (
                <div class="button button-blue-primary button-block-centered-text mt-0 w-button">
                  Saving...
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </nav>
  );
}
